<template>
  <div class="min-h-screen bg-gray-200 dark:bg-gray-800 flex justify-center overflow-hidden">
    <div class="w-full max-w-screen-xl">
      <!-- Contenuto senza header -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutNoHeader'
};
</script>
